import React from "react";
import { Container, Row, Col, FormGroup, Button } from 'reactstrap';
import ReactExport from "react-export-excel";
import DatePicker from "../Form/DatePicker";
import { FormLabel } from "../Form/FormLabel";
import moment from 'moment';
import { useState } from "react";
import { endpoints } from "../../utils/Constants";
import { useEffect } from "react";
import LoadingAnimation from "../Form/LoadingAnimation";
import useFetch from "../../Services/useFetch";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//const ExcelExport = () => <></>;

const ExcelExport = ({ jobTracker, data }) => {

    const thisQuarter = parseInt((new Date().getMonth() + 1) / 3);
    const year = thisQuarter === 0 ? new Date().getFullYear() - 1 : new Date().getFullYear();
    const lastQuarter = thisQuarter === 0 ? 4 : thisQuarter - 1;
    const fromDate = new Date(year, (lastQuarter * 3) - 1, 1);
    const toDate = new Date(year, lastQuarter * 3 + 2, 1);
    const [from, setFrom] = useState(moment(fromDate));
    const [to, setTo] = useState(moment(toDate));
    const [reportData, loading, error, refresh] = useFetch(!data && jobTracker ? endpoints.charterReport + from.format('YYYY-MM-DDTHH:mm:ss') + "/" + to.format('YYYY-MM-DDTHH:mm:ss') : null, {}, false);
    const [reportDetails, setReportDetails] = useState();
    const handleChangeFrom = (e) => {
        setFrom(moment(e));
        setReportDetails();

    };

    const handleChangeTo = (e) => {
        setTo(moment(e));
        setReportDetails();

    }
    useEffect(() => {
        data && setReportDetails(data);
    }, [data]);
    useEffect(() => {
        reportData && setReportDetails(reportData);
    }, [reportData])

    const getQuarter = (d) => {
        const thisQuarter = d && d.getMonth ? parseInt((d.getMonth() + 1) / 3) : 1;
        return d && d.getFullYear ? d.getFullYear() + " - Q" + thisQuarter : year + " - Q" + thisQuarter;
    }
    const getOparatorName = (detail, index) => {
        if (detail.bids && detail.bids.length > index) {
            return detail.bids[index].supplier.companyName;
        }
        return "";
    };
    const getTotalJobValue = (detail, index) => {
        if (detail.bids && detail.bids.length > index) {
            return detail.bids[index].price > detail.bids[index].withMargin ? detail.bids[index].price + detail.bids[index].withMargin : detail.bids[index].withMargin;
        }
        return "";
    }
    const getPax = (detail) => {
        if (detail.manifest && detail.manifest.length) {
            return detail.manifest.length;
        }
        else {
            return Math.max(detail.route[0].passengerNumber, detail.route[0].passengerRange_Max);
        }
    }
    const getWeight = (detail) => {

        return detail.manifest ? detail.manifest.reduce((a, x) => a + (x.freightWeight ? x.freightWeight : 0) + (x.cargoWeight ? x.cargoWeight : 0) + (x.passengerWeight ? x.passengerWeight : 0), 0) : 0;
    }

    return <Container>
        {jobTracker ? <Row>
            <Col>
                <FormGroup>
                    <FormLabel>From</FormLabel>
                    <DatePicker disabled={loading} type='datetime-local' placeholder="Report From" onChange={handleChangeFrom} selected={moment(from).toDate()} />
                </FormGroup>
            </Col>
            <Col>
                <FormGroup>
                    <FormLabel>To</FormLabel>
                    <DatePicker disabled={loading} type='datetime-local' placeholder="Report To" onChange={handleChangeTo} selected={moment(to).toDate()} />
                </FormGroup>
            </Col>
        </Row> : null}
        {loading ? <LoadingAnimation /> : jobTracker && !reportDetails ? <Button onClick={refresh}>Load</Button> : null}
        {error ? <h5>Error Loading Report</h5> : null}
        {reportDetails ? <ExcelFile element={<button type='button'>Download Data</button>}>
            {jobTracker ? <ExcelSheet data={reportDetails} name="Job History">

                <ExcelColumn label='Created' value={(detail) => {
                    return detail.request.createdAt
                }} />
                <ExcelColumn label='AVMIN' value="" />
                <ExcelColumn label='JB' value={(detail) => {
                    return detail.request.jobReference
                }} />
                <ExcelColumn label='Type' value={(detail) => {
                    return detail.request.charterSubType
                }} />
                <ExcelColumn label='Charter' value={(detail) => {
                    return detail.request.qGov ? "QG" : "STD"
                }} />
                <ExcelColumn label='Manager' value="" />
                <ExcelColumn label='Client Department' value={(detail) => {
                    return detail.clientDepartment?.departmentName
                }} />
                <ExcelColumn label='Client' value={(detail) => {
                    return detail.clientStaff ? detail.clientStaff.fullName : detail.clientDepartment ? detail.clientDepartment.fullName : detail.client?.fullName
                }} />
                <ExcelColumn label='Out Date' value={(detail) => {
                    return detail.route ? detail.route[0]?.departTime : detail.request.departTime;
                }} />
                <ExcelColumn label='Departing' value={(detail) => {
                    return detail.route[0]?.from
                }} />
                <ExcelColumn label='Rtn Date' value={(detail) => {
                    return detail.route[detail.route.length - 1]?.departTime
                }} />
                <ExcelColumn label='Arriving' value={(detail) => {
                    return detail.route[detail.route.length - 1]?.to
                }} />
                <ExcelColumn label='VIA' value="" />
                <ExcelColumn label='P / F #' value="" />
                <ExcelColumn label='Job Status' value={(detail) => {
                    return detail.request.status
                }} />
                <ExcelColumn label='Winning Operator' value={(detail) => {
                    return detail?.bid?.supplier?.companyName
                }} />
                <ExcelColumn label='Date' value={(detail) => {
                    return detail?.bid?.createdAt
                }} />
                <ExcelColumn label='BUY' value={(detail) => {
                    return detail?.bid?.price
                }} />
                <ExcelColumn label='SELL' value={(detail) => {
                    return detail?.bid?.price > detail.bid?.withMargin ? detail.bid?.price + detail.bid?.withMargin : detail.bid?.withMargin
                }} />
                <ExcelColumn label='Margin' value={(detail) => {
                    return detail?.bid?.price > detail.bid?.withMargin ? detail.bid?.withMargin : detail.bid?.withMargin - detail.bid?.prirce
                }} />
                <ExcelColumn label='Invoice #' value="" />
                <ExcelColumn label='Aircraft' value={(detail) => {
                    var aircraft = detail.bid?.routes && detail.bid.routes.length && detail.bid.routes[0] && detail.bid.routes[0].aircraft && detail.bid.routes[0].aircraft.length ? detail.bid.routes[0].aircraft[0] : null;
                    return aircraft ? aircraft.name + " " + aircraft.licenseNumber : null;
                }} />
                <ExcelColumn label='Original $' value={(detail) => {
                    return detail.bid && detail.bid.price > detail.bid.withMargin ? detail.bid?.price + detail.bid?.withMargin : detail.bid?.withMargin
                }} />
                <ExcelColumn label='Difference' value="" />
                <ExcelColumn label='A / POW' value="" />
                <ExcelColumn label='Booked Q' value={(detail) => {
                    return getQuarter(new Date(detail.request.createdAt))
                }} />
                <ExcelColumn label='Operating Q' value={(detail) => {
                    return getQuarter(new Date(detail.route[0]?.departTime))
                }} />
                <ExcelColumn label='Time Created' value={(detail) => {
                    return new Date(detail.request.createdAt)
                }} />
                <ExcelColumn label='First Quote' value={(detail) => {
                    return detail.bids && detail.bids.length ? new Date(detail.bids[0].createdAt) : '';
                }} />
                <ExcelColumn label='Wait' value={(detail) => {
                    if (detail.bids && detail.bids.length && detail.request) {
                        //const startTime = detail.request.createdAt;
                        //const endTime = detail.bids[0].createdAt;
                        //const [startTime, endTime] = [detail.request.createdAt, detail.bids[0].createdAt].map(moment);
                        // Time from creation till 17:00 that day (or 0 if creation was after 17:00)
                        //const firstDayDuration = (moment(startTime).isAfter(moment(startTime).startOf('day').add(17, 'hours'))) ? moment.duration(0) : moment.duration(moment(startTime).diff(moment(startTime).startOf('day').add(17, 'hours')));
                        // Time since 8:00 till the first bid placed that day (or 0 if creation was after 17:00)
                        //const lastDayDuration = (moment(endTime).isBefore(moment(endTime).startOf('day').add(8, 'hours'))) ? moment.duration(0) : moment.duration(moment(endTime).diff(moment(endTime).startOf('day').add(8, 'hours')));
                        //const daysBetween = moment(startTime).startOf('day').add(1, 'days').diff(moment(endTime).startOf('day'), 'days');
                        var duration = moment.duration(moment(detail.bids[0].createdAt).diff(moment(detail.request.createdAt)));
                        var hours = duration.asMinutes();
                        return hours;
                    }
                    return 0;
                }} />
                <ExcelColumn label='Urgent ?' value={(detail) => {
                    return detail.request.urgent ? 'Y' : 'N'
                }} />
                <ExcelColumn label='Reason' value={(detail) => {
                    return detail?.request.reason
                }} />
                <ExcelColumn label='Final PAX' value={(detail) => {
                    return getPax(detail)
                }} />
                <ExcelColumn label='Final Weight' value={(detail) => {
                    return getWeight(detail)
                }} />
                <ExcelColumn label='Operator #1' value={(detail) => {
                    return getOparatorName(detail, 0)
                }} />
                <ExcelColumn label='TJV $' value={(detail) => {
                    return getTotalJobValue(detail, 0)
                }} />
                <ExcelColumn label='Operator #1' value={(detail) => {
                    return getOparatorName(detail, 1)
                }} />
                <ExcelColumn label='TJV $' value={(detail) => {
                    return getTotalJobValue(detail, 1)
                }} />
                <ExcelColumn label='Operator #1' value={(detail) => {
                    return getOparatorName(detail, 2)
                }} />
                <ExcelColumn label='TJV $' value={(detail) => {
                    return getTotalJobValue(detail, 2)
                }} />
                <ExcelColumn label='Operator #1' value={(detail) => {
                    return getOparatorName(detail, 3)
                }} />
                <ExcelColumn label='TJV $' value={(detail) => {
                    return getTotalJobValue(detail, 3)
                }} />
                <ExcelColumn label='Operator #1' value={(detail) => {
                    return getOparatorName(detail, 4)
                }} />
                <ExcelColumn label='TJV $' value={(detail) => {
                    return getTotalJobValue(detail, 4)
                }} />
                <ExcelColumn label='Comments' value="" />

            </ExcelSheet> :
                <ExcelSheet data={reportDetails} name="Charter List">
                    <ExcelColumn label='Status' value={(detail) => {
                        return detail.request.status
                    }} />
                    <ExcelColumn label='Job Reference' value={(detail) => {
                        return detail.request.jobReference
                    }} />
                    <ExcelColumn label='PO Number' value={(detail) => {
                        return detail.request.purchaseOrderNumber
                    }} />
                    <ExcelColumn label='Depart Time' value={(detail) => {
                        return detail.request.departTime
                    }} />
                    <ExcelColumn label='From' value={(detail) => {
                        return detail.request.from
                    }} />
                    <ExcelColumn label='To' value={(detail) => {
                        return detail.request.to
                    }} />
                    <ExcelColumn label='Remaining' value={(detail) => {
                        return detail.request.createdAt
                    }} />
                    <ExcelColumn label='Sectors' value={(detail) => {
                        return detail.request.routeCount
                    }} />
                    <ExcelColumn label='Bids' value={(detail) => {
                        return detail.request.bidCount
                    }} />
                    <ExcelColumn label='Special Requests' value={(detail) => {
                        return detail.request.specialRequests
                    }} />

                </ExcelSheet>}
        </ExcelFile> : null}
    </Container>;

}

export default ExcelExport